import { c as _c } from "react/compiler-runtime";
import { InfoTooltip } from '@morpho-org/ui-v6/client';
import { Icon } from '@repo/ui';
import { Info } from '@repo/ui/icons';
interface RecapLabeledRowProps {
  label: string;
  /** Omitted while the recap loads: a decorative icon keeps its place, so the label wraps the same. */
  tooltip?: React.ReactNode;
  value: React.ReactNode;
}

/**
 * A recap's "label + info tooltip + right-aligned value" row.
 *
 * `InfoTooltip` carries the focus and button semantics a bare `TooltipTrigger` around an `Icon`
 * does not, so the fee and net-received explanations can be read by keyboard. It leaves the
 * tooltip's own content alone, which matters here: some of these tooltips carry a link.
 */
const RecapLabeledRow = t0 => {
  const $ = _c(12);
  const {
    label,
    tooltip,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-secondary-foreground text-xs">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== tooltip) {
    t2 = tooltip === undefined ? <Icon aria-hidden={true} className="text-secondary-foreground" icon={<Info />} /> : <InfoTooltip tooltipContent={tooltip} />;
    $[2] = tooltip;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="gap-2xs flex min-w-0 items-start">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== value) {
    t4 = <span className="text-foreground text-right text-xs whitespace-nowrap">{value}</span>;
    $[7] = value;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="gap-sm grid grid-cols-[minmax(0,1fr)_auto] items-start">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default RecapLabeledRow;